<app-card>
  <div class="header">
    <h3>{{ "devices.favorites" | translate }}</h3>
    <a
      [routerLink]="['/', RouteConstants.routeDevice]"
      class="button icon-button end"
    >
      {{ "devices.all" | translate }}
      <app-icon name="ic_chevron_right" />
    </a>
  </div>
  <mat-tab-group>
    @if (devices$ | async; as devices) {
      <mat-tab [label]="'devices.devices' | translate">
        <div class="flex-1">
          <div class="grid grid-cols-devices">
            @for (device of devices; track device.id) {
              <app-device-item-card
                [device]="device"
                [disabled]="!isSystemRunning"
                (triggerDeviceAction)="onTriggerDeviceAction($event)"
              />
            } @empty {
              {{ "devices.favoritesEmpty" | translate }}
            }
          </div>
        </div>
      </mat-tab>
    }
    @if (deviceGroups$ | async; as deviceGroups) {
      <mat-tab [label]="'deviceGroups.deviceGroups' | translate">
        <div class="flex-1">
          <div class="grid grid-cols-1">
            @for (deviceGroup of deviceGroups; track deviceGroup.id) {
              <app-area-item-card
                [deviceGroup]="deviceGroup"
                [disabled]="!isSystemRunning"
                (triggerDeviceGroupAction)="onTriggerDeviceGroupAction($event)"
              />
            } @empty {
              {{ "devices.favoritesEmpty" | translate }}
            }
          </div>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</app-card>
